export default __webpack_public_path__ + "static/media/menuCopiar.6f3d2021.svg";